import type { ErrorInfo, ReactNode } from "react";

import React from "react";

export const createLogger = () => {
  return {
    log: (message: string | Error, ...args: any[]) => {
      console.log(message, ...args);
    },
    error: (message: string | Error, ...args: any[]) => {
      // console.error always called in case DD_RUM is not available
      console.error(message, ...args);

      if (import.meta.env.MODE !== "development" && !!window.DD_RUM) {
        if (
          window.DD_RUM.hasOwnProperty("addError") &&
          typeof window.DD_RUM.addError === "function"
        )
          window.DD_RUM.addError(message, ...args);
      }
    },
    warn: (message: string | Error, ...args: any[]) => {
      console.warn(message, ...args);
    },
    info: (message: string | Error, ...args: any[]) => {
      console.info(message, ...args);
    },
  };
};

export const logger = createLogger();

type ErrorBoundaryProps = {
  fallback: ReactNode;
  children: ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

export class DatadogErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    logger.error(error, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return this.props.fallback;
    }

    return this.props.children;
  }
}
